import { createFileRoute } from '@tanstack/react-router'
import { requireCompleteProfile } from '@/lib/auth-guard'
import { useState, useEffect } from 'react'
import { useAuth } from '@/context/auth-context'
import { useLeaderboard, useDashboard } from '@/lib/queries'
import LeaderBoardNavbar from '@/components/application/leaderboard/LeaderBoardNavbar'
import LeaderAvatar from '@/components/application/leaderboard/LeaderAvatar'
import LeaderboardTable from '@/components/application/leaderboard/LeaderboardTable'
import LoadingSpinner from '@/components/LoadingSpinner'

const LeaderboardPage = () => {
  const { user } = useAuth()
  const [currentPage, setCurrentPage] = useState(1)
  
  // Get user data from dashboard API
  const { data: dashboardData } = useDashboard(user?.id)
  const streak = dashboardData?.user.challenges.streak || 0
  const totalPoints = dashboardData?.user.totalScore || 0
  
  // Fetch leaderboard data
  const { data: leaderboardData = [], isLoading } = useLeaderboard();

  // Transform data for display
  const leaderboardWithPosition = leaderboardData.map((leader, index) => ({
    ...leader,
    position: index + 1,
    score: Number(leader.weeklyScore) || 0,
  }));

  // Split into top 3 and rest
  const top6 = leaderboardWithPosition.slice(0, 6);
  const restOfLeaders = leaderboardWithPosition.slice(6);

  // All time graph Data
  const [allPointsLabels, setAllPointsLabels] = useState<string[]>([]);
  const [allPointsData, setAllPointsData] = useState<number[]>([]);

  // Pagination
  const itemsPerPage = 4;
  const totalPages = Math.ceil(restOfLeaders.length / itemsPerPage);
  const paginatedLeaders = restOfLeaders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const tempDataTopAllPoints = [
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 198,
      score: 198,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {},
      fullName: "Eison Chiang",
      id: "1",
      lastScoreTime: "2025-09-11 05:16:56.063Z",
      user: "cdxmxiq7sws4y59",
      weeklyScore: 550,
      score: 550,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 730,
      score: 730,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 250,
      score: 250,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 190,
      score: 190,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 230,
      score: 230,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 299,
      score: 299,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 304,
      score: 304,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 450,
      score: 450,
    },
    {
      collectionId: "j8f0b98rmavwj5i",
      collectionName: "leaderboard",
      expand: {
        user: {
          avatar: "avatar_se29sg6h7sptpt8_1757368215041_9m1zf4y715.png",
          birthdate: "",
          collectionId: "_pb_users_auth_",
          collectionName: "users",
          created: "2024-12-30 09:26:16.229Z",
          email: "aboudirawas@gmail.com",
          emailVisibility: false,
          id: "se29sg6h7sptpt8",
          name: "aboudirawas",
          updated: "2025-09-09 10:43:26.237Z",
          username: "abouleabed",
          verified: true,
        },
      },
      fullName: "aboudirawas",
      id: "2",
      lastScoreTime: "2025-09-11 00:10:57.254Z",
      user: "se29sg6h7sptpt8",
      weeklyScore: 533,
      score: 533,
    },
  ];

  useEffect(() => {
    if (!tempDataTopAllPoints) return;

    const labels = tempDataTopAllPoints
      .slice(0, 9)
      .map((s) => s.expand?.user?.name ?? "Unknown");
    const data = tempDataTopAllPoints.slice(0, 9).map((s) => s.score ?? 0);

    setAllPointsLabels(labels);
    setAllPointsData(data);
  }, [leaderboardData]);

  if (isLoading) {
    return (
      <>
        <LeaderBoardNavbar points={totalPoints} streaks={streak} />
        <div className="flex items-center justify-center min-h-[60vh]">
          <LoadingSpinner text="Loading leaderboard..." />
        </div>
      </>
    );
  }

  return (
    <>
      {/* <LeaderBoardNavbar points={totalPoints} streaks={streak} /> */}
      <div className="relative min-h-screen container m-auto ">
        <div className="relative z-10">
          <h1 className="text-[48px] font-bold mb-12">Leaderboard</h1>

          {/* Top 6 avatars */}
          {top6.length > 0 && (
            <div className="w-1/3">
              <LeaderAvatar labels={allPointsLabels} data={allPointsData} />
            </div>
          )}

          {/* Rest of leaderboard */}
          {restOfLeaders.length > 0 && (
            <LeaderboardTable
              leaders={paginatedLeaders}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </div>
      </div>
    </>
  );
};

export const Route = createFileRoute("/leaderboard")({
  ...requireCompleteProfile(),
  component: LeaderboardPage,
});
